import React from 'react';

import cx from 'classnames';

import Text from 'components/shared/Typography/Text';
import { Wysiwyg } from 'components/shared/Wysiwyg';
import { LOREM_IPSUM_TEXT } from 'constants/texts';

import s from '../../index.module.css';

export const BLOCK_ROLE = {
  PARAGRAPH: 'paragraph',
  LINE: 'line',
} as const;

//@ts-ignore
function TextBlock({ block }) {
  return (
    <Text className={cx(s.paragraph, block.role === BLOCK_ROLE.LINE && s.noMargin)} italic={block.italic}>
      {block.data.title && (
        <Text className={s.title} isStrong>
          {block.data.title}
        </Text>
      )}
      {(block.data.raw || block.data.text) && (
        <Wysiwyg data={block.data} placeholder={block.data?.placeholder?.text || LOREM_IPSUM_TEXT} isReadOnly />
      )}
    </Text>
  );
}

export default TextBlock;
